import Head from "next/head";
import React from "react";

import Link from "next/link";
import WordpressApi, { Menus } from "../../../services/wordpressApi";
import Blog from "../../news-blog-deutsch-sprachschule";

// import Pagination from "../../components/elements/Pagination";

export default Blog;
export async function getServerSideProps({ query }: any) {
  let data: any;
  let page: any;
  let menus = {};
  let pageNumber = query.page;

  try {
    [data, page, menus] = await Promise.all([
      WordpressApi.getBlogPosts(pageNumber, "en"),
      WordpressApi.getPage("blog", "en"),
      WordpressApi.getMenus("en"),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
  return {
    props: {
      posts: data,
      htmlHead: page?.htmlHead,
      tags: page.tags,
      data: page.blocks,
      menus: menus,
      lang: "en",
    },
  };
}
